import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FallSharpIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M23 19C14.99 19 13.01 4.03 12.99 3.88C12.93 3.38 12.5 3 12 3C11.5 3 11.07 3.38 11.01 3.88C10.99 4.03 9.01 19 1 19C0.45 19 0 19.45 0 20C0 20.55 0.45 21 1 21C7.49 21 10.61 13.86 12 8.86C13.39 13.86 16.51 21 23 21C23.55 21 24 20.55 24 20C24 19.45 23.55 19 23 19Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FallSharpIcon.displayName = 'FallSharpIcon';
